import React from 'react';
import ReactDOM from 'react-dom/client';
import { FilterService } from 'primereact/api';
import App from './App';

// Register custom amount filter for PrimeReact DataTable
// This filter does exact numeric matching instead of substring matching
FilterService.register('custom_amount', (value: any, filter: any): boolean => {
  if (filter === null || filter === undefined || filter === '') {
    return true;
  }
  if (value === null || value === undefined) {
    return false;
  }

  // Convert value to number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) {
    return false;
  }

  // Strip currency formatting from filter input ($, commas)
  const cleanFilter = String(filter).replace(/[$,]/g, '').trim();
  const filterNum = parseFloat(cleanFilter);
  if (isNaN(filterNum)) {
    return true; // Invalid filter input, show all
  }

  // Compare absolute values with small tolerance for floating point
  const absValue = Math.abs(numValue);
  return Math.abs(absValue - filterNum) < 0.01;
});

// PrimeReact Themes and Styles
import './styles/primereact-theme.scss'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import './styles/material-symbols-outlined.css'

// Custom Styles
import './styles/base.scss'

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
